export const JOBMANAGER_URL = '/jobmanager';
export const XING_JOBS_URL = '/jobs';
